import { useState, useEffect } from "react";
import { DEFAULT_FETCH_PARAM_SIZE } from "../../../helpers/constant/misc";
import { useIsMounted } from "../../../hooks/useIsMounted";
import { TrafficSource } from "../../../services/TrafficSource";

export const useFetchTrafficSources = () => {
  const [trafficSources, setTrafficSources] = useState([]);

  const [loadingTrafficSources, setLoadingTrafficSources] = useState({
    isLoading: false,
    error: false
  });

  const isMounted = useIsMounted();

  function getParams() {
    let params = {};

    params["order_by"] = "id";
    params["order_direction"] = "ASC";
    params["size"] = DEFAULT_FETCH_PARAM_SIZE;

    return params;
  }

  async function getTrafficSources() {
    try {
      setLoadingTrafficSources({ isLoading: true, error: false });
      const trafficSources = await TrafficSource.fetchTrafficSources(
        getParams()
      );
      if (trafficSources.success && isMounted()) {
        let receivedTrafficSources = [];
        for (let p of trafficSources.data.traffic_sources) {
          receivedTrafficSources.push({
            label: p.name,
            value: p.id,
            status: p.status
          });
        }
        setTrafficSources(receivedTrafficSources);
        setLoadingTrafficSources({ isLoading: false, error: false });
      } else {
        throw new Error(trafficSources.error.message);
      }
    } catch (error) {
      if (isMounted()) {
        setTrafficSources([]);
        setLoadingTrafficSources({ isLoading: false, error: true });
      }
      console.trace(error.message || error);
    }
  }

  useEffect(() => {
    getTrafficSources();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    loadingTrafficSources,
    trafficSources
  };
};
